import React from "react";
import { Button, Icon } from "@telia/teddy";
import { RootState } from "../../../../../../models";
import { isBankIdVerified } from "../../../../authentication/state/selectors";
import { isBroadbandCustomer } from "../../../state/selectors";
import { useDispatch, useSelector, connect } from "react-redux";
import { selectors as LOADING_SELECTORS } from "../../../../loading";
import PAGES from "../../../../../../constants/pages";
import { submitOrder } from "../../../state/actions";
import * as AT from "../../../state/actionTypes";

interface StateProps {
    canContinue: boolean;
    broadbandCustomer: boolean;
}

type SummaryContinueButtonProps = StateProps;

const SummaryContinueButton: React.FC<SummaryContinueButtonProps> = () => {
    const dispatch = useDispatch();
    const canContinue = useSelector((state: RootState) => isBankIdVerified(state));
    const isSubmitting = useSelector((state: RootState) =>
        LOADING_SELECTORS.isTypeLoading(state, AT.TELIA_PLAY_SUBMIT_ORDER),
    );
    const broadbandCustomer = useSelector((state: RootState) => isBroadbandCustomer(state));
    if (broadbandCustomer) {
        return (
            <Button id="customer-form-button" variant="primary" asChild>
                <a href="https://www.telia.no/minside/">
                    Gå til Min Side <Icon name="arrow-right" aria-hidden="true" />
                </a>
            </Button>
        );
    }

    const onSubmit = () => {
        dispatch(submitOrder()).then(
            ({ orderRef }) => window.location.assign(`${PAGES.TELIA_PLAY.RECEIPT.URL}${encodeURIComponent(orderRef)}/`),
            () => undefined,
        );
    };
    return (
        <Button
            id="customer-form-button"
            variant="primary"
            onClick={onSubmit}
            disabled={!canContinue || isSubmitting}
            loading={isSubmitting}
            type="submit"
        >
            Fullfør bestilling
            <Icon name="arrow-right" aria-hidden="true" />
        </Button>
    );
};

const mapStateToProps = (state: RootState): StateProps => ({
    canContinue: isBankIdVerified(state) && !isBroadbandCustomer(state),
    broadbandCustomer: isBroadbandCustomer(state),
});

export default connect(mapStateToProps)(SummaryContinueButton);
